import axios from "axios";
const { REACT_APP_GOOGLE_DRIVE_API_BASE_URL } = process.env;
const BASE_URL = `${REACT_APP_GOOGLE_DRIVE_API_BASE_URL}`;
export default axios.create({
  baseURL: BASE_URL,
});

export const googleDriveAxios = axios.create({
  baseURL: process.env.REACT_APP_GOOGLE_DRIVE_API_BASE_URL,
  withCredentials: true,
});
